import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { ReactComponent as IconPlaceholder } from '../../../assets/placeholders/IconPlaceholder.svg'
import { ColorBoxContent } from '../../../common/ui/colorBox'

function TotalExpenditureCell({ bundleUsage, date }) {
  return (
    <ColorBoxContent
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '150px'
      }}
    >
      <IconPlaceholder
        style={{
          width: '100px',
          height: '100px',
          borderRadius: '100px',
          margin: '0 16px 0 0'
        }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant='h5'>Total Expenditure</Typography>
        <Typography variant='h2' sx={{ margin: '0px 4px' }}>
          SGD${bundleUsage.expenditure.toFixed(2)}{' '}
        </Typography>
        <Typography>
          <i>As of {date}</i>
        </Typography>
      </Box>
    </ColorBoxContent>
  )
}

TotalExpenditureCell.propTypes = {
  bundleUsage: PropTypes.object,
  date: PropTypes.string
}

export default TotalExpenditureCell
